<div class="fullcontainer">
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields and add at least one line</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">
      @if (this.serverErrorMessage) {
        {{ this.serverErrorMessage }}
      } @else {
        Something went wrong. Please try again later.
      }
    </div>
  }
  <div class='sheet'>
    <h1 class='header'>Book goods out</h1>
    <form (ngSubmit)='this.onSubmit()' method='post'>
      <app-stock-operation-form [operation]='this.operation' [operationType]='this.operationType'></app-stock-operation-form>
      <button type="submit" class="btn btn-success">Post</button>&nbsp;
      <button type="button" class="btn btn-danger" routerLink='/warehousing/stock-levels'>Cancel</button>
    </form>
  </div>
</div>
